import { render, staticRenderFns } from "./TransformerPartsOverview.vue?vue&type=template&id=0b3a40a8&scoped=true&lang=pug"
import script from "./TransformerPartsOverview.vue?vue&type=script&lang=js"
export * from "./TransformerPartsOverview.vue?vue&type=script&lang=js"
import style0 from "./TransformerPartsOverview.vue?vue&type=style&index=0&id=0b3a40a8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3a40a8",
  null
  
)

export default component.exports